export default __webpack_public_path__ + "static/VideoBanner_2-718237133fcd89314b6f3e715c556681.mp4";